import { useEffect, useState } from 'react';
import styles from './Printing.module.css';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Checkbox, Tooltip } from '@material-ui/core';
import PrintIcon from '@mui/icons-material/Print';
import { useRef } from 'react';
import QueryBuilder from 'components/common/QueryBuilder/QueryBuilder';
import { usePrintableGroupLogic } from './hooks/usePrintableGroupLogic';
import LoadIndicator from 'components/common/LoadIndicator/LoadIndicator';
import ConfirmDialog from 'components/common/ConfirmDialog/ConfirmDialog';
import { useModifierApi } from 'pages/PhotoAdmin/AdminMenu/Templates/hooks/useModifierApi';
import { usePrinterApi } from 'pages/PrinterAdmin/hooks/usePrinterApi';
import { useSelector } from 'react-redux';
import { Grow } from '@mui/material';
import { FileBrowserInfoCard } from 'components/PhotoAdminComponents/Orders/FileBrowserInfoCard/FileBrowserInfoCard';
import { useTranslation } from 'react-i18next';
const Printing = () => {
  const navigate = useNavigate();
  const { getModifiers, modifiers } = useModifierApi();
  const { search } = useLocation();
  const { t } = useTranslation();

  const [showAll, setShowAll] = useState(false);
  const [isPrintingDoneAll, setIsPrintingDoneAll] = useState(false);
  const [isPrintedAll, setIsPrintedAll] = useState(false);

  const [isDeliveryType, setIsDeliveryType] = useState(false);

  const [open, setOpen] = useState();

  const [allSelected, setAllSelected] = useState(false);

  const { fetchGroups, printGroup, groups, setGroups, loading, groupsLength, setGroupsLength } =
    usePrintableGroupLogic();

  const { printGroupFinal } = usePrinterApi();

  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);

  const toggleGroup = (groups, currentGroup) => {
    const newGroups = groups.map((group) => {
      if (group.id === currentGroup.id) {
        return { ...group, selected: !group.selected };
      }
      return group;
    });
    setGroups(newGroups);
  };
  const handleShowAll = () => {
    setShowAll(!showAll);
  };

  const handleSelectAll = (groups, e) => {
    setAllSelected(e.target.checked);
    const newGroups = groups.map((group) => ({
      ...group,
      selected: e.target.checked
    }));
    setGroups(newGroups);
  };

  const handlePrint = async () => {
    let promises = [];
    groups?.forEach(async (group) => {
      if (group.selected) {
        let newGroup = { ...group };
        delete newGroup.selected;
        let promise = printGroup({
          group: { ...newGroup, isPrinted: true }
        });
        promises.push(promise);
      }
    });
    await Promise.all(promises);
    let printer = '';
    if (search.includes('isActive=ISPRINTED')) {
      printer = search.replace('isActive=ISPRINTED', 'isPrinted=true&isPrintingDone=false');
    } else if (search.includes('isActive=ISPRINTINGDONE')) {
      printer = search.replace('isActive=ISPRINTINGDONE', 'isPrintingDone=true');
    } else if (search.includes('isActive=ISNOTPRINTED')) {
      printer = search.replace('isActive=ISNOTPRINTED', 'isPrinted=false');
    }
    await fetchGroups({ queryString: printer === '' ? search : printer });
  };
  const handlePrintEnding = async () => {
    let promises = [];
    groups?.forEach(async (group) => {
      if (group.selected) {
        let newBody = { ...group };
        delete newBody.selected;
        newBody.isPrintingDone = true;
        let promise = printGroupFinal({
          group: { ...newBody }
        });
        promises.push(promise);
      }
    });
    await Promise.all(promises);
    refresh();
  };

  const refresh = () => {
    let printer = '';
    if (search.includes('isActive=ISPRINTED')) {
      printer = search.replace('isActive=ISPRINTED', 'isPrinted=true&isPrintingDone=false');
    } else if (search.includes('isActive=ISPRINTINGDONE')) {
      printer = search.replace('isActive=ISPRINTINGDONE', 'isPrintingDone=true');
    } else if (search.includes('isActive=ISNOTPRINTED')) {
      printer = search.replace('isActive=ISNOTPRINTED', 'isPrinted=false');
    }
    fetchGroups({ queryString: printer === '' ? search : printer });
  };

  const checkSelfPrint = () => {
    let isSelf = false;
    modifiers?.forEach((el) => {
      if (el?.deliveryTypeDTO?.includes('LELKES')) {
        isSelf = true;
      }
    });
    setIsDeliveryType(isSelf);
  };

  const linkRef = useRef(null);

  // Add dummy data for disabled printing
  const dummyGroups = [
    {
      id: 'DEMO-001',
      name: t('printing.dummy1'),
      createdAt: new Date().toISOString(),
      isActive: true,
      isPrinted: false,
      isPrintingDone: false,
      selected: false
    },
    {
      id: 'DEMO-002',
      name: t('printing.dummy2'),
      createdAt: new Date().toISOString(),
      isActive: true,
      isPrinted: true,
      isPrintingDone: false,
      selected: false
    },
    {
      id: 'DEMO-003',
      name: t('printing.dummy3'),
      createdAt: new Date().toISOString(),
      isActive: true,
      isPrinted: true,
      isPrintingDone: true,
      selected: false
    }
  ];

  useEffect(() => {
    if (shopTier?.printOption) {
      let printer = '';
      if (search.includes('isActive=ISPRINTED')) {
        printer = search.replace('isActive=ISPRINTED', 'isPrinted=true&isPrintingDone=false');
      } else if (search.includes('isActive=ISPRINTINGDONE')) {
        printer = search.replace('isActive=ISPRINTINGDONE', 'isPrintingDone=true');
      } else if (search.includes('isActive=ISNOTPRINTED')) {
        printer = search.replace('isActive=ISNOTPRINTED', 'isPrinted=false');
      }
      fetchGroups({ queryString: printer === '' ? search : printer });
    } else {
      setGroups(dummyGroups);
      setGroupsLength(dummyGroups.length);
    }
  }, [search, shopTier?.printOption]);

  // Update loading state for dummy data
  const isLoading = shopTier?.printOption ? loading : false;

  useEffect(() => {
    getModifiers();
    refresh();
  }, []);

  useEffect(() => {
    checkSelfPrint();
    console.log(user);
  }, [modifiers]);

  useEffect(() => {
    setIsPrintingDoneAll(groups?.find((el) => el.isPrintingDone === true) ? true : false);
    setIsPrintedAll(groups?.find((el) => el.isPrinted === true) ? true : false);
  }, [groups]);

  const path = useLocation().pathname;

  const resetQueryString = () => {
    navigate(path);
  };

  const findPaperDate = ({ group }) => {
    const date = group?.productGroupModifierValidities?.find((el) =>
      el.modifierUriSegment.includes('paper')
    )?.validUntil;

    return date
      ? new Date(date).toLocaleString('hu-HU', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      : t('common.noData');
  };
  const printingValidation = () => {
    const selectedGroups = groups?.filter((el) => el.selected);

    if (!shopTier?.printOption || !selectedGroups?.length) {
      const message = 'Jelölj ki iskolát a funkció használatához!';
      return {
        print: { message, enabled: false },
        finalizePrint: { message, enabled: false }
      };
    }

    let canPrint = true;
    let canFinalize = true;
    let printMessage = 'Kijelölt iskolák és azok által tartalmazott galériák küldése nyomtatásra!';
    let finalizeMessage = 'Kijelölt iskolák és azok által tartalmazott galériák nyomtatásának véglegesítése!';

    for (const elem of selectedGroups) {
      const paperDate = new Date(findPaperDate({ group: elem }));
      const now = new Date();

      if (elem.isPrinted && elem.isPrintingDone) {
        canPrint = false;
        canFinalize = false;
        printMessage = 'Már nyomtatásra küldött galériát nem küldhetsz újra nyomtatásra!';
        finalizeMessage = 'Már véglegesített galériát nem lehet újból véglegesíteni!';
        break; // végleges állapot, kiléphetünk
      }

      if (!elem.isPrinted && !elem.isPrintingDone && paperDate > now) {
        canPrint = false;
        printMessage = 'Ameddig nem jár le a rendelési idő nem küldheted nyomtatásra az iskolát!';
        // finalizePrint így is tiltott marad, mert nincs nyomtatva
        finalizeMessage = 'Csak a már nyomtatóra küldött galériák nyomtatása véglegesíthető!';
        // nincs break, mert nézhetünk még hibásabbat
      }

      if (!elem.isPrinted) {
        finalizeMessage = 'Csak a már nyomtatóra küldött galériák nyomtatása véglegesíthető!';
        canFinalize = false;
      }

      if (elem.isPrinted && !elem.isPrintingDone) {
        // lehet finalizálni
        canPrint = false;
        printMessage = 'Már nyomtatásra küldött galériát nem küldhetsz újra nyomtatásra!';
        continue;
      }
    }

    return {
      print: { message: printMessage, enabled: canPrint },
      finalizePrint: { message: finalizeMessage, enabled: canFinalize }
    };
  };

  return (
    <Container maxWidth={false} className={styles.root}>
      <CssBaseline />
      <a ref={linkRef} />
      <Breadcrumbs aria-label='breadcrumb' className={styles.breadcrumb}>
        <Typography style={{ fontFamily: 'var(--font-main)' }} variant='body1'>
          {t('printing.title')}
        </Typography>
      </Breadcrumbs>

      <Grow in={true}>
        <Container maxWidth={false} className={styles.container}>
          <FileBrowserInfoCard
            fileBrowserUrl={`${window._env_.REACT_APP_BASE_URL?.split('://')[0]}://files.${
              window._env_.REACT_APP_BASE_URL?.split('://')[1]
            }`}
            username={user?.username || 'printeruser'}
            password={user?.fileBrowserPassword || 'printerpassword'}
          />
          <QueryBuilder
            itemsLength={groupsLength}
            siteType={'admin'}
            showAll={showAll}
            reset={resetQueryString}
            refresh={refresh}
            disabled={!shopTier?.printOption}>
            <table className={styles.headerTop}>
              <tbody>
                <tr width='100%' className={styles.searchBar}>
                  <td
                    // className={classes.hideXs}
                    style={{
                      color: 'whitesmoke',
                      textAlign: 'center',
                      display: 'flex',
                      gap: '1rem'
                    }}>
                    <Tooltip title={printingValidation()?.print?.message}>
                      <span>
                        <Button
                          variant='outlined'
                          style={{
                            backgroundColor:
                              printingValidation()?.print?.enabled && 'var(--primary-background-content)',
                            color: 'var(--primary-background-primary)',
                            fontFamily: 'var(--font-main) !important',
                            marginTop: 0,
                            border: `2px solid var(--primary-background-primary)`,
                            transition: 'background 300ms'
                            // opacity: !deliveries?.find(
                            //   (delivery) => delivery.selected
                            // )
                            //   ? 0.3
                            //   : 1,
                          }}
                          disabled={!printingValidation()?.print?.enabled}
                          onClick={() => setOpen('printConfirm')}>
                          <PrintIcon />
                          {t('printing.sendPrint')}
                        </Button>
                      </span>
                    </Tooltip>
                    {isDeliveryType ? (
                      <Tooltip title={printingValidation()?.finalizePrint?.message}>
                        <span>
                          <Button
                            variant='outlined'
                            style={{
                              backgroundColor:
                                printingValidation()?.finalizePrint?.enabled && 'var(--primary-background-content)',
                              color: 'var(--primary-background-primary)',
                              margin: 0,
                              border: `2px solid var(--primary-background-primary)`,
                              fontFamily: 'var(--font-main) !important',
                              transition: 'background 300ms'
                            }}
                            disabled={!printingValidation()?.finalizePrint?.enabled}
                            onClick={() => setOpen('printEnding')}>
                            <PrintIcon />
                            {t('printing.printEnding')}
                          </Button>
                        </span>
                      </Tooltip>
                    ) : (
                      ''
                    )}
                    <ConfirmDialog
                      open={open === 'printConfirm'}
                      title={t('printing.sure')}
                      functionButtonText={t('printing.printer')}
                      functionButtonColor='var(--primary-success)'
                      demo={!!user?.ownedShops?.find((shop) => shop.id == shopId)?.isDemo}
                      onOk={async () => {
                        setOpen(null);
                        await handlePrint();
                        setAllSelected(false);
                      }}
                      onClose={() => setOpen(null)}
                      closeButtonText={t('common.cancel')}
                      multipleButtons
                    />
                    <ConfirmDialog
                      open={open === 'printEnding'}
                      title={t('printing.sureEnding')}
                      functionButtonText={t('printing.printEnding')}
                      functionButtonColor='var(--primary-success)'
                      onOk={async () => {
                        setOpen(null);
                        await handlePrintEnding();
                        setAllSelected(false);
                      }}
                      onClose={() => setOpen(null)}
                      closeButtonText={t('common.cancel')}
                      multipleButtons
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <table className={styles.header}>
              <thead>
                <tr width='100%'>
                  <td className={styles.heading} width='10%'>
                    <Checkbox
                      style={{ color: 'whitesmoke' }}
                      checked={allSelected}
                      onChange={(e) => handleSelectAll(groups, e)}
                      disabled={!shopTier?.printOption}
                    />
                  </td>
                  <td className={styles.hideXs} style={{ width: '5%' }}>
                    <Typography className={styles.heading}>#</Typography>
                  </td>
                  <td className={styles.hideXs} style={{ width: '10%' }}>
                    <Typography className={styles.heading}>{t('printing.id')}</Typography>
                  </td>
                  <td className={styles.heading}>
                    <Typography className={styles.heading}>{t('printing.schoolName')}</Typography>
                  </td>
                  <td className={styles.heading}>
                    <Typography className={styles.heading}>{t('printing.printDeadline')}</Typography>
                  </td>
                  <td className={styles.hideXs}>
                    <Typography className={styles.heading}>{t('printing.status')}</Typography>
                  </td>
                  <td className={styles.tableCell}>
                    <Typography className={styles.heading}>{t('printing.printStatus')}</Typography>
                  </td>
                </tr>
              </thead>
            </table>
            <div className={styles.orderListContainer}>
              <table className={styles.listitemtable}>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td>
                        <LoadIndicator color={'var(--primary-light)'} height={800} />
                      </td>
                    </tr>
                  ) : groups?.length > 0 ? (
                    groups?.map((group, idx) => (
                      <tr
                        className={shopTier?.printOption ? styles.listItem : styles.listItemDisabled}
                        width='100%'
                        key={group.id}
                        onClick={() => {
                          if (shopTier?.printOption) {
                            toggleGroup(groups, group);
                          }
                        }}>
                        <td className={styles.tableCell} width='10%'>
                          <Checkbox
                            color='primary'
                            checked={group?.selected}
                            onChange={(e) => toggleGroup(groups, group)}
                            disabled={!shopTier?.printOption}
                          />
                        </td>
                        <td className={styles.hideXs} style={{ width: '5%' }}>
                          <Typography className={styles.tableCell}>{idx + 1}</Typography>
                        </td>
                        <td className={styles.hideXs} style={{ width: '10%' }}>
                          <Typography className={styles.tableCell}>{group?.id}</Typography>
                        </td>
                        <td className={styles.tableCell}>
                          <Typography className={styles.tableCell}>{group?.name}</Typography>
                        </td>
                        <td className={styles.tableCell}>
                          {group?.createdAt && (
                            <Typography className={styles.tableCell}>{findPaperDate({ group: group })}</Typography>
                          )}
                        </td>

                        <td className={styles.hideXs}>
                          <Typography
                            style={{
                              fontFamily: 'var(--font-main)',
                              color: group?.isActive ? 'rgb(25,109,235)' : 'var(--primary-error)'
                            }}>
                            {group?.isActive ? t('printing.active') : t('printing.inactive')}
                          </Typography>
                        </td>
                        <td className={styles.tableCell}>
                          <Typography
                            style={{
                              fontFamily: 'var(--font-main)',
                              color: !group?.isPrinted
                                ? 'black'
                                : group?.isPrinted && !group?.isPrintingDone
                                ? 'rgb(204, 204, 0 )'
                                : 'var(--primary-success)',
                              fontWeight: group?.isPrinted && group?.isPrintingDone && 'bold'
                            }}>
                            {!group?.isPrinted
                              ? t('printing.printable')
                              : group?.isPrinted && !group?.isPrintingDone
                              ? t('printing.waiting')
                              : t('printing.printed')}
                          </Typography>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr
                      style={{
                        margin: '0.5rem',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                      }}>
                      <td>
                        <Typography variant='h5' style={{ color: 'var(--primary-light)' }}>
                          {shopTier?.printOption ? t('printing.noPrintable') : t('printing.noPrintOption')}
                        </Typography>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </QueryBuilder>

          <button
            className={styles.allBtn}
            onClick={() => {
              handleShowAll();
            }}>
            {showAll ? t('printing.lessGallery') : t('printing.allGallery')}
          </button>
        </Container>
      </Grow>
    </Container>
  );
};

export default Printing;
